<app-layout>
    <admin-reports-tab section="system_wallets"></admin-reports-tab>
    <h1 class="mt-10 mb-8 font-bold text-3xl">
        System Wallets
    </h1>
    <div class="mb-5"><small>PLEASE NOTE: The system syncs all wallet balances every 15 minutes.</small></div>

    <div class="mb-6 flex justify-between flex-column items-center">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4 focus:outline-none" @reset="reset">
            <label class="block text-gray-700">Wallet Type:</label>
            <select v-model="form.type" class="mt-1 w-full form-select rounded">
                <option value="all">All</option>
                <option value="coin">Coin</option>
                <option value="fiat">Fiat</option>
            </select>
        </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-3 pt-6 pb-4">Currency</th>
                <th class="px-3 pt-6 pb-4">Type</th>
                <th class="px-3 pt-6 pb-4">Balance</th>
                <th class="px-3 pt-6 pb-4">Last synced</th>
            </tr>
            <tr v-for="currency in currencies.data" :key="currency.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <span class="px-3 py-2 flex items-center">
                        {{ currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-4 flex items-left">
                        <badge v-if="currency.type == 'coin'" class="mr-2" type="gray">
                            {{ 'coin' }}
                        </badge>
                        <badge v-if="currency.type == 'fiat'" class="mr-2" type="green">
                            {{ 'fiat' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex  items-left">
                        {{ parseFloat(currency.wallet_balance) + parseFloat(currency.wallet_balance_erc) + parseFloat(currency.wallet_balance_trc) + parseFloat(currency.wallet_balance_bep)  }} {{ currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-3 py-2 flex  items-left">
                        <badge v-if="currency.wallet_balance_updated_at" type="green">
                            {{ currency.wallet_balance_updated_at }}
                        </badge>
                        <badge v-else type="gray">
                            {{ 'not synced yet' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="currencies.data.length === 0">
                <td class="border-t px-3 py-2" colspan="100">No wallets found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="currencies.links" />
</app-layout>
